export default {
  // common pages
  'account.profile': '/:realm/account-settings/profile',
  'account.changePassword': '/:realm/account-settings/change-password',
  'store.profile': '/:realm/store-settings/profile',
  'account.notification': '/:realm/account-settings/notification',
  'store.customName': '/:realm/store-settings/custom-name',
  'store.storeReconnect': '/:realm/store-settings/store-reconnect',

  // growz
  growz: '/growz/dashboard',
  'growz.trial': '/growz/start-trial',
  'growz.postTrial': '/growz/post-trial',
  'growz.products': '/growz/products',
  'growz.products.outOfBudget': '/growz/products?tableFilterKey=outOfStock&tableFilterValue=Yes',
  'growz.products.searchSuppressed': '/growz/products?tableFilterKey=suppressed&tableFilterValue=Yes',
  'growz.products.lowInventory': '/growz/products?tableFilterKey=lowInventory&tableFilterValue=Yes',
  'growz.campaigns': '/growz/campaigns',
  'growz.campaigns.adSpend': '/growz/campaigns?tableFilterKey=adSpend&tableFilterValue=20',
  'growz.campaigns.outOfBudget': '/growz/campaigns?tableFilterKey=servingStatus&tableFilterValue=CAMPAIGN_OUT_OF_BUDGET',
  'growz.campaigns.conversionDrop': '/growz/campaigns?tableFilterKey=conversionDrop&tableFilterValue=Yes',
  'growz.campaigns.spendingLessBudget': '/growz/campaigns?tableFilterKey=spendingLessBudget&tableFilterValue=Yes',
  'growz.campaigns.budgetUtilization': '/growz/campaigns?tableFilterKey=budgetUtilization&tableFilterValue=Yes',
  'growz.campaigns.type': '/growz/campaigns/:type',
  'growz.microgoals': '/growz/strategy',
  'growz.analyze': '/growz/recommendation',
  'growz.keywordResearch': '/growz/keyword',
  'growz.reverseAsin': '/growz/keyword/reverse-asin',
  'growz.microgoals.launched': '/growz/strategy/launched',
  'growz.campaigns.search': '/growz/campaigns?startDate=:startDate&endDate=:endDate',
  'growz.campaigns.goals': '/growz/campaigns/:campaignId/view?active=2',
  'growz.campaigns.adGroups': '/growz/campaigns/adgroup/:adGroupId/view?startDate=:startDate&endDate=:endDate',
  'growz.microgoals.launch': '/growz/strategy/:goalSlug/launch',
  'growz.microgoals.activity': '/growz/strategy/:id/activity',
  'growz.launched.strategy': '/growz/strategy/:goalSlug',
  'growz.strategy.asin': '/growz/strategy/asin/:asin',
  'growz.microGoalId': '/growz/micro-goal/:goalSlug',
  'growz.campaigns.view': '/growz/campaigns/:campaignId/view',
  'growz.adGroup.view': '/growz/campaigns/adgroup/:adGroupId/view',
  'growz.campaigns.view.search': '/growz/campaigns/:campaignId/view?startDate=:startDate&endDate=:endDate',
  'growz.campaigns.adGroup.keyword': '/growz/campaigns/adgroup/:adGroupId/keyword/scout/:id/view',
  'growz.microgoals.activity.edit': '/growz/strategy/:id//activity/edit',
  'growz.rank.tracker': '/growz/rank-tracker',
  'rank.tracker.dashboard': '/growz/rank-tracker/:id',
  'growz.adGroup.target.bidding.details': '/growz/campaigns/adgroup/:adGroupId/target/bidding/:strategy/details',

  // growz-reports
  'growz.reports.comparison': '/growz/reports/comparison',
  'growz.reports.placement': '/growz/reports/placement-reports',
  'growz.reports.brand.metrics.category': '/growz/reports/brand-metrics-category-report',

  // growz-creatives
  'growz.creatives.dashboard': '/growz/creatives/dashboard',
  'growz.creatives.create': '/growz/creative',
  'growz.creatives.create.sb': '/growz/creative/sb',
  'growz.creatives.create.sd': '/growz/creative/sd',

  // aisle
  aisle: '/aisle/market-stream',
  'aisle.create': '/aisle/create',
  'aisle.list': '/aisle/list',
  'aisle.edit': '/aisle/:aisleId/edit',
  'aisle.list.report': '/aisle/list/:aisleId/:i/report',

  // stores
  'stores.first': '/stores/first',
  stores: '/stores/list',
  users: '/stores/users',
  'users.add': '/stores/users/add',
  roles: '/stores/roles',
  'roles.create': '/stores/roles/create',

  // account-health
  'account.health': '/growz/account-health',
  'account.health.account': '/growz/account-health/account-level',
  'account.health.product': '/growz/account-health/product-level',

  // auth
  login: '/login',
  'login.newUser': '/login?newUser=:newUser',
  logout: '/logout',
  register: '/register',
  verifyEmail: '/verify-email?email=:emailId',
  finishSignUp: 'finish-sign-up',

  // onboarding
  marketplace: '/marketplace',
  onboarding: '/onboarding',
  'onboarding.store': '/onboarding/:storeId',

  // Intro
  'growz.intro': '/growz/intro',
  'growz.overview': '/growz/overview',
  'aisle.intro': '/aisle/intro',

  // market-stream
  'aisle.marketstream': '/aisle/market-stream',
  'aisle.marketstream.list': '/aisle/market-stream/list',
  'aisle.marketstream.list.view': '/aisle/market-stream/list?id=:id',
  'aisle.marketstream.launch': '/aisle/market-stream/:campaignId/launch',

  // sso
  'sso.amazon.login': '/sso/amazon/login?autopilot=:value',
  'sso.amazon.elevate': '/sso/amazon/login?elevate=true',
  'sso.amazon.ads': '/sso/amazon/ads',
  'sso.amazon.sp': '/sso/amazon/sp?storeId=:storeId',
  'sso.amazon.sp.vendor': '/sso/amazon/sp-vendor?storeId=:storeId',
  'sso.amazon.reconnect-ads': '/sso/amazon/reconnect/ads',
  'sso.amazon.reconnect-sp': '/sso/amazon/reconnect/sp',
  'sso.amazon.reconnect-sp-vendor': '/sso/amazon/reconnect/sp-vendor',
  'sso.google.login': '/sso/google/login',

  'launch.campaign': '/growz/campaign-launcher',
  'launch.sp.campaign': '/growz/campaign-launcher/sp',
  'launch.sd.campaign': '/growz/campaign-launcher/sd',
  'launch.sb.campaign': '/growz/campaign-launcher/sb',

  // subscription
  'subscription.plans': '/:realm/subscription/plans',
  'subscription.selectAddOns': '/:realm/subscription/checkout/add-ons',
  'subscription.activePlan': '/:realm/subscription/active-plan',
  'subscription.addOns': '/:realm/subscription/add-ons',
  'subscription.invoices': '/:realm/subscription/invoices',
  'subscription.usages': '/:realm/subscription/usage',

  // alerts and notifications
  notifications: '/:realm/notifications',
  alerts: '/:realm/alerts',
  'alerts.type': '/:realm/alerts/:type',

  // asin-analyzer-fix
  'asin.sp.fix.details': '/growz/asin/sp/:asin/fix/details',
  'asin.sd.fix.details': '/growz/asin/sd/:asin/fix/details',
  'asin.sb.fix.details': '/growz/asin/sb/:asin/fix/details',

  // reports
  'reports.keywords.sortBySpend': '/growz/reports/store-keyword?tableSortKey=cost&tableSortOrder=desc',

  // seller-gpt
  sellergpt: '/:realm/sellergpt',
};
